import "parsleyjs";
class Forms {
    forms = null;
    parsleyParams = {
        excluded: Parsley.options.excluded + ', input:hidden, select:hidden, textarea:hidden',
        errorClass: 'is-invalid',
        successClass: 'is-valid',
        errorsWrapper: '<div class="invalid-feedback leading-tight"></div>',
        errorTemplate: '<span></span>',
        errorsContainer: function (Field) {
            if (Field.element.type === 'checkbox' || Field.element.type === 'radio') {
                return Field.$element.closest('.input').find('> :visible:last');
            }
        },
        classHandler: function (Field) {
            if (Field.element.type === 'checkbox' || Field.element.type === 'radio') {
                return Field.$element.closest('.input').find('> :visible input');
            }
        }
    }
    
    constructor(forms) {
        this.forms = forms;
    }
    
    submitButton() {
        // Loop over them and prevent submission
        Array.prototype.filter.call(this.forms, function(form) {
            form.addEventListener('submit', function(event) {
                if ($(form).parsley().isValid()) {
                    let submitting = event.submitter.querySelector('[data-submitting-text]');
                    let submitText = event.submitter.querySelector('[data-submit-text]');
                    if (submitting) submitting.classList.remove('d-none');
                    if (submitText && submitting) submitText.classList.add('d-none');
                }
            }, false);
        });

        return this;
    }
    
    validate() {
        $(this.forms).parsley(this.parsleyParams);
        return this;
    }
}

export default Forms;